export const Works = (props) => {
  return (
    <div id="works" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>How Unreal Kingdoms works?</h2>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-12 works-cards">
            <div className="col-md-6 col-xl-12">
              <div className="card">
                <h3>🎯 Play!</h3>
                <p>
                  Create your own story and shape your own destiny in a fully
                  immersive open world gaming experience. Be part of an
                  ever-growing community where dreams truly do come true.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-12">
              <div className="card">
                <h3>⚡ Collect!</h3>
                <p>
                Meet our Metaverse full of creatures. Defeat them to earn collectible NFTs which you can sell, trade, or take them to your next adventure.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-12">
              <div className="card">
                <h3>📦 Trade!</h3>
                <p>
                In the Metaverse, furniture, houses, creatures, art, and more are all NFTs that can be bought and sold. Some will be rare. Some will be valuable.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-xl-12">
              <div className="card">
                <h3>🌎 Dream!</h3>
                <p>
                What will you do with your own plot in the Metaverse? Build a dream home, an art gallery, a dance club , a mystery house, a park, a restaurant... the opportunities are endless.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
